import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _camelCase from "lodash/camelCase";
var _excluded = ["payload"];
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es7.object.entries.js";

/**
 * Analytics fields that can be consumed as camel-cased props.
 */
var ALLOWED_RAW_ANALYTICS_PAYLOAD_FIELDS = ['element_position', 'entity_name', 'model_execution_ids', 'section_name', 'section_position'];
var PROP_TO_FIELD_MAP = ALLOWED_RAW_ANALYTICS_PAYLOAD_FIELDS.reduce(function (acc, fieldName) {
  return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, _camelCase(fieldName), fieldName));
}, {});
/**
 * Provided some analytics config (in its various shapes) normalize it to a raw analytics payload.
 * Raw "payload" specified config will be consumed blindly whereas sanitized props will be privileged.
 *
 * @todo We should converge on strategy for analytics specification.
 */

export var getRawAnalyticsPayload = function getRawAnalyticsPayload() {
  var analyticsConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _analyticsConfig$payl = analyticsConfig.payload,
      payload = _analyticsConfig$payl === void 0 ? {} : _analyticsConfig$payl,
      analyticsProps = _objectWithoutProperties(analyticsConfig, _excluded);

  var sanitizedProps = Object.fromEntries(Object.entries(analyticsProps).map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        fieldName = _ref2[0],
        value = _ref2[1];

    return [PROP_TO_FIELD_MAP[fieldName], value];
  }).filter(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
        rawFieldName = _ref4[0],
        value = _ref4[1];

    return rawFieldName && value != null;
  }));
  return _objectSpread(_objectSpread({}, payload), sanitizedProps);
};